<div class="row form">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="page-title-box form__head">
        <div class="row align-items-center">
          <div class="col-sm-6 col-6">
            <a class="page-title form__head__title" (click)="cancel()">
              <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} servicio
            </a>
          </div>
          <div class="col-sm-6 col-6 form__head__boxBtn">
            <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <div class="card m-b-30">
        <div class="card-body">
          <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-lg-12">
                <div class="row">
                  <div class="form-group col-lg-3">
                    <label>Tipo producto<span class="required"></span></label>
                    <select class="form-control" formControlName="type_product" id="type_product">
                      <option *ngFor="let item of type_products" [value]="item.id">{{ item.description }}</option>
                    </select>
                  </div>
                  <div class="form-group col-lg-3">
                    <label>
                      <span data-toggle="tooltip" data-placement="right" data-original-title="Código de barras"><i
                          class="fas fa-info-circle f-s-14"></i></span>
                      Código <span class="badge badge-info m-l-5" *ngIf="!isEdit">Se va asignar uno</span></label>
                    <input type="text" id="product_code" maxlength="25" class="form-control text-uppercase"
                      formControlName="code">
                  </div>
                  <div class="form-group col-lg-6">
                    <label>Nombre del producto<span class="required"></span></label>
                    <input type="text" id="product_description" required class="form-control" autofocus
                      formControlName="description">
                  </div>
                </div>
              </div>
              <div class="col-lg-9">
                <div class="row">                    
                  <div class="form-group col-lg-4">
                    <label>Unidad medida</label>
                    <select class="form-control" id="unitSelected"  disabled>
                      <option *ngFor="let item of units" [value]="item.id">{{ item.description }}</option>
                    </select>
                  </div>
                  <div class="form-group col-lg-4">
                    <div class="custom-control custom-checkbox m-t-5">
                      <input type="checkbox" class="custom-control-input" id="is_show" name="is_show"
                        formControlName="is_show">
                      <label class="custom-control-label p-t-3" for="is_show">Es visible</label>
                    </div>
                  </div>
                  <div class="form-group col-lg-4">
                    <div class="custom-control custom-checkbox m-t-5">
                      <input type="checkbox" class="custom-control-input" id="is_favorite" name="is_favorite"
                        formControlName="is_favorite">
                      <label class="custom-control-label p-t-3" for="is_favorite">Es favorito en
                        venta</label>
                    </div>
                  </div>  
                  <div class="col-lg-12 m-t-10">
                    <p class="form__group__title"> <i class="fa fa-money-bill m-r-3"></i>Asignar precio al producto</p>
                    <div class="row">
                      <div class="form-group col-lg-6">
                        <label>Seleccionar tipo precio<span class="required"></span></label>
                        <select class="form-control" (change)="changeTypePrice()" disabled>
                          <option *ngFor="let item of typeprices" [value]="item.id">{{ item.description }}</option>
                        </select>
                      </div>
                      <ng-container *ngIf="item.value.typeprice_id == typeprice_general">
                        <div class="form-group col-lg-3">
                          <label>
                            <span data-toggle="tooltip" data-placement="right"
                              data-original-title="Precio de venta general" title=""><i
                                class="fas fa-info-circle f-s-14"></i></span>
                            <span class="text-primary price-general bold">PV. GENERAL</span><span class="required"></span>
                          </label>
                          <div class="input-group">
                            <span class="input-group-prepend"><span
                                class="input-group-text">{{toolsService.momeySol()}}</span></span>
                            <input type="text" id="price_sale" class="form-control bold text-primary" numeric decimals="2"
                              onclick="click_input(this)" [(ngModel)]="price_general.price_sale"
                              [ngModelOptions]="{standalone: true}">
                          </div>
                        </div>
                        <div class="form-group col-lg-9" style="display: none;">
                          <p class="bold">Otros precios referenciales</p>
                          <div class="row">
                            <div class="form-group col-lg-4">
                              <label><span data-toggle="tooltip" data-placement="right"
                                  data-original-title="Precio de venta mínimo" title=""><i
                                    class="fas fa-info-circle f-s-14"></i></span>
                                PV. mínimo
                              </label>
                              <div class="input-group">
                                <span class="input-group-prepend"><span class="input-group-text">S/</span></span>
                                <input type="text" class="form-control bold" numeric decimals="2"
                                  onclick="click_input(this)" [(ngModel)]="price_general.price_min"
                                  [ngModelOptions]="{standalone: true}">
                              </div>
                            </div>
                            <div class="form-group col-lg-4">
                              <label><span data-toggle="tooltip" data-placement="right"
                                  data-original-title="Precio crédito" title=""><i
                                    class="fas fa-info-circle f-s-14"></i></span>
                                PV. crédito
                              </label>
                              <div class="input-group">
                                <span class="input-group-prepend"><span class="input-group-text">S/</span></span>
                                <input type="text" class="form-control bold" onclick="click_input(this)"
                                  [(ngModel)]="price_general.price_credit" [ngModelOptions]="{standalone: true}">
                              </div>
                            </div>
                            <div class="form-group col-lg-4">
                              <label><span data-toggle="tooltip" data-placement="right"
                                  data-original-title="Precio mayorista" title=""><i
                                    class="fas fa-info-circle f-s-14"></i></span>
                                PV. mayorista
                              </label>
                              <div class="input-group">
                                <span class="input-group-prepend"><span class="input-group-text">S/</span></span>
                                <input type="text" class="form-control bold" onclick="click_input(this)"
                                  [(ngModel)]="price_general.price_wholesaler" [ngModelOptions]="{standalone: true}">
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
  
                <div class="row">
                  <div class="form-group col-lg-12">
                    <label>Descripción del producto</label>
                    <textarea id="product_comment" formControlName="comment" class="form-control no-resize"
                      rows="2"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <p class="text-center p-t-15">
                  <ng-container *ngIf="item.value.url_image != null">
                    <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
                  </ng-container>
                  <ng-container *ngIf="item.value.url_image == null">
                    <ng-container *ngIf="imageUrl == null">
                      <img id="output" width="200" src="/images/default.png" />
                    </ng-container>
                    <ng-container *ngIf="imageUrl != null">
                      <img width="200" height="165" [src]="imageUrl" alt="Preview">
                    </ng-container>
                  </ng-container>
                </p>
                <p class="text-center">
                  <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                    Seleccionar Imagen
                    <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                      style="visibility: hidden;">
                  </label>
                </p>
              </div>
              <div class="form-group col-lg-12 form__footerBtn">
                <div class="text-right">
                  <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                  <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                    <i class="far fa-save m-r-5"></i>
                    <ng-container *ngIf="!isEdit">
                      Guardar
                    </ng-container>
                    <ng-container *ngIf="isEdit">
                      Guardar Cambios
                    </ng-container>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  
